import styled, { css } from 'styled-components';
import { Typography } from '@interstate/components/Typography';
import type { BaseDealBreakpoint } from '../../utils/useBaseDealBreakpoint';

export const CategoryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
`;

export const CategoryTitle = styled(Typography)`
    margin-bottom: 0 !important;
`;

export const CategoryHeaderActions = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 16px;
    margin-left: auto;
`;

export const FeesHeaderContainer = styled.div<{ baseBreakPoint: BaseDealBreakpoint; isDealCentralMultiScenario: boolean }>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #b2b2b2;
    color: #6d6d6d;
    font-size: 12px;
    padding: 12px 0;
    gap: 16px;
    margin-bottom: 8px;
`;

export const FieldHeader = styled.div<{
    isLease?: boolean;
    isEmpty?: boolean;
    isAmount?: boolean;
    isName?: boolean;
    isTaxedColumn?: boolean;
}>`
    white-space: nowrap;
    ${({ isEmpty, isLease, isTaxedColumn }) =>
        isEmpty &&
        css`
            width: ${isTaxedColumn ? 97 : !isLease ? 32 : 120}px !important;
        `}
    ${({ isEmpty }) =>
        !isEmpty &&
        css`
            flex: 1;
        `};
`;
